import {
  type MapCircleSelection,
  type MapSelection,
  MapSelectionMode,
  type MapSourceSelection,
} from 'components/KNMapLibre/types'
import i18n from 'i18n'
import { uniqueId } from 'lodash'
import { type Area, AreaType, type CircleArea, type SourceArea } from './CarrierProfile.types'

export const areasToMapSelections = (areas: Area[], color?: string): MapSelection[] =>
  areas.map((area) => areaToMapSelection(area, color))
    .filter((selection) => selection !== null)

export const areaToMapSelection = (area: Area, color?: string): MapSelection | null => {
  if (area.type === AreaType.SOURCE) {
    return {
      mode: MapSelectionMode.SOURCE,
      source: (area as SourceArea).source,
      code: (area as SourceArea).code,
      color,
    } as MapSourceSelection
  } else if (area.type === AreaType.CIRCLE) {
    return {
      mode: MapSelectionMode.CIRCLE,
      center: [(area as CircleArea).center.longitude, (area as CircleArea).center.latitude],
      radius: (area as CircleArea).radius,
      color,
    } as MapCircleSelection
  }
  return null
}

export const mapSelectionToArea = (selection: MapSelection, name?: string): Area | null => {
  if (selection.mode === MapSelectionMode.SOURCE) {
    return {
      id: uniqueId('new_source_'),
      type: AreaType.SOURCE,
      name: name ?? i18n.t(`countries.${(selection as MapSourceSelection).code}`),
      source: (selection as MapSourceSelection).source,
      code: (selection as MapSourceSelection).code,
    } as SourceArea
  } else if (selection.mode === MapSelectionMode.CIRCLE) {
    return {
      id: uniqueId('new_radius_'),
      type: AreaType.CIRCLE,
      name: name ?? `${(selection as MapCircleSelection).center[1]}, ${(selection as MapCircleSelection).center[0]}`,
      center: { latitude: (selection as MapCircleSelection).center[1], longitude: (selection as MapCircleSelection).center[0] },
      radius: (selection as MapCircleSelection).radius,
    } as CircleArea
  }
  return null
}

export const isAreaAlreadySelected = (area: Area, selection: MapSelection): boolean => {
  if (area.type === AreaType.SOURCE && selection.mode === MapSelectionMode.SOURCE) {
    return (area as SourceArea).source === (selection as MapSourceSelection).source && (area as SourceArea).code === (selection as MapSourceSelection).code
  }
  return false
}

export const enumToBooleanFormValues = <E, F extends Record<string, boolean>>(allValues: E[], currentValues?: E[]) =>
  Object.fromEntries(
    allValues.map((value) => [
      value,
      currentValues?.includes(value) ?? false,
    ]),
  ) as F

export const booleanFormValuesToEnum = <F extends Record<string, boolean>, E>(formValues: F) =>
  Object.entries(formValues)
    .filter(([_, value]) => value)
    .map(([key]) => key) as E[]

export const minAreasValidator = (areas: Area[]) =>
  areas.length === 0 ? i18n.t('screens.cs.carrier_profile.lanes_and_regions.form.validation.min_areas') : true
